export default "<section ng-show=\"$ctrl.selected\" ng-transclude></section>";